import { MoleculeVideoOverlayProps, MyMoleculeVideoOverlayLayout1 } from 'wolf/components/molecules/m-video-overlay/m-video-overlay.data';
import { Component, StyleSettings } from '../../../../global/interfaces/component.interface';
import { AtomButtonProps } from '../../atoms/a-button/a-button.data';
import { v4 as uuidv4 } from 'uuid';
import { AtomImageProps } from 'wolf/components/atoms/a-image/a-image.data';

const videoPosterImage = require('../../../../global/assets/images/video-poster.jpg') as string;

export interface VideoData {
	/** The youtube video ID */
	videoId: string;
	/** Player settings */
	settings: VideoSettings;
	/** A placeholder poster image shown before the video is played */
	poster: AtomImageProps;
	/** A small video thumbnail. Used when the video is in a slideshow */
	thumb?: string;
	/** This needs to be like a unique uuid. Support for multiple videos of the same videoId on the same page */
	instanceId?: string;
}
interface VideoSettings {
	/** If true, the video will begin muted */
	mute: boolean;
	/** If true, the video controls will be shown */
	controls: boolean;
	/** If true, the video will play on a loop */
	loop: boolean;
}
/**
 * The cookie overlay
 * @todo - could be a molecule one day?
 */
interface CookieContentOverlayProps {
	/** The cookie consent headline */
	headline: string;
	/** The cookie consent message */
	text: string;
	/** The button to give cookie consent */
	buttonAccept: AtomButtonProps;
	/** If true, the cookie message will not show */
	alreadyGivenConsent?: boolean;
}
export interface OrganismVideoProps extends StyleSettings {
	/** The molecule headline text */
	// headline: AtomHeadlineProps;
	/** The molecule copy text */
	// copy: AtomCopyProps;
	/** The button in the text */
	// button?: AtomButtonProps;

	overlay: MoleculeVideoOverlayProps;

	/** Video consent cookie overlay */
	consent: CookieContentOverlayProps;
	/** Main video data */
	video: VideoData;

	oneTrust?: any;
}

const poster = {
	sources: [
		{
			mediaQuery: '(max-width: 1920px)',
			image: 'https://picsum.photos/1920/1024',
			width: 1920,
			height: 1024
		},
		{
			mediaQuery: '(max-width: 1200px)',
			image: 'https://picsum.photos/1200/600',
			width: 1200,
			height: 600
		},
		{
			mediaQuery: '(max-width: 768px)',
			image: 'https://picsum.photos/768/480',
			width: 768,
			height: 480
		},
	],
	alt: 'lorem ipsum test',
	title: 'lorem ipsum',
	width: 1920,
	height: 1080
}

export const MyOrganismVideoDefault: Component<OrganismVideoProps> = {
	data: {
		overlay: MyMoleculeVideoOverlayLayout1.data,
		consent: {
			headline: 'Notice about cookies which must be accepted first',
			text: '<p>In order to watch the video you <strong>must accept cookies</strong>...Lorem ipsum dolor sit amet consectetur adipisicing elit. Explicabo, aspernatur nostrum, ipsam alias unde, vel cumque incidunt eius vitae ratione odio nobis ipsa error sequi harum architecto!</p>',
			buttonAccept: {
				href: '#accept-consent',
				text: 'Accept and show video',
				title: '',
				type: 'default-blue',
			},
		},
		video: {
			instanceId: uuidv4(),
			videoId: 'tgdbb87PY9k',
			// videoId: '3x4Kgn-vICY', // YouTube
			settings: {
				// autoplay: false,
				mute: false,
				controls: false,
				loop: false,
			},
			poster,
		},
		styleSettings: {
			paddingStyle: 'standard',
			textColor: 'true-white',
			headlineColor: 'true-white',
			isEmbedded: true,
		},
	},
};

export const MyOrganismVideoStyledContent: Component<OrganismVideoProps> = {
	data: {
		...MyOrganismVideoDefault.data,
		// headline: {
		// 	text: 'Der Luftreiniger Der Profis',
		// 	style: 1,
		// },
		styleSettings: {
			paddingStyle: 'standard',
			textColor: 'warning', // this comes from SCSS $colors and will color style the copy and play button
			headlineColor: 'danger',
			copyColor: 'success',
			isEmbedded: true,
		},
	},
};

const doesNotRequireConsent = JSON.parse(JSON.stringify(MyOrganismVideoDefault.data)) as OrganismVideoProps;
// override consent check (shouldn't be used on Prod!)
doesNotRequireConsent.consent.alreadyGivenConsent = true;
export const MyOrganismVideoDoesNotRequireConsent: Component<OrganismVideoProps> = {
	data: doesNotRequireConsent,
};

